(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vso-satc"] && !Shopify.designMode) return;
  try {
    
(function() {
  function ensurePortal() {
    let portal = document.getElementById("versio-sticky-atc-portal");
    if (portal) return portal;
    portal = document.createElement("div");
    portal.id = "versio-sticky-atc-portal";
    document.body.appendChild(portal);
    return portal;
  }

  function portalize(blockEl) {
    if (!blockEl || !blockEl.parentNode) return;
    const portal = ensurePortal();

    const existing = Array.from(portal.querySelectorAll("[data-versio-sticky-atc]"));
    existing.forEach((el) => {
      if (el !== blockEl) el.remove();
    });

    if (blockEl.parentElement === portal) return;

    const anchor = document.createElement("span");
    anchor.setAttribute("data-versio-sticky-atc-anchor", "true");
    anchor.style.display = "none";
    blockEl.parentNode.insertBefore(anchor, blockEl);
    blockEl.__versioStickyAtcAnchor = anchor;

    const sectionWrapper = anchor.closest && anchor.closest('[id^="shopify-section-"]');
    if (sectionWrapper && sectionWrapper.id) {
      blockEl.dataset.versioSectionId = sectionWrapper.id;
    }

    portal.appendChild(blockEl);
  }

  function findProductForm(root) {
    const scope = root || document;
    const preferred =
      scope.querySelector('product-form form[action^="/cart/add"]') ||
      scope.querySelector('product-form form[action*="/cart/add"]') ||
      scope.querySelector('form[id^="product-form-"][action^="/cart/add"]') ||
      scope.querySelector('form[id^="product-form-"][action*="/cart/add"]') ||
      null;
    if (preferred) return preferred;

    const candidates = Array.from(
      scope.querySelectorAll('form[action^="/cart/add"], form[action*="/cart/add"]')
    );
    return candidates.find((form) => form.querySelector('[name="id"]')) || candidates[0] || null;
  }

  function findSubmitButton(form) {
    if (!form) return null;
    return (
      form.querySelector('button[type="submit"]:not([disabled])') ||
      form.querySelector('input[type="submit"]:not([disabled])') ||
      form.querySelector('button[type="submit"], input[type="submit"]')
    );
  }

  function findBuyButtonsTarget(form, submit) {
    if (!form) return null;

    const withinForm =
      form.querySelector(".product-form__buttons") ||
      form.querySelector(".product__buttons") ||
      form.querySelector(".shopify-payment-button") ||
      form.querySelector('[data-shopify="payment-button"]') ||
      null;
    if (withinForm) return withinForm;

    const submitEl = submit || findSubmitButton(form);
    if (submitEl) return submitEl;

    return form;
  }

  async function addToCartFallback(variantId) {
    const body = new URLSearchParams();
    body.append("id", String(variantId));
    body.append("quantity", "1");
    const res = await fetch("/cart/add.js?ts=" + Date.now(), {
      method: "POST",
      headers: { Accept: "application/json" },
      body,
      cache: "no-store",
    });
    if (!res.ok) throw new Error("Failed to add to cart");
    return res.json();
  }

  async function fetchCart() {
    const res = await fetch("/cart.js?ts=" + Date.now(), {
      headers: { Accept: "application/json" },
      cache: "no-store",
    });
    if (!res.ok) throw new Error("Failed to fetch cart");
    return res.json();
  }

  function variantInCart(cart, variantId) {
    const id = String(variantId || "");
    return (cart.items || []).some((item) => item && String(item.variant_id) === id);
  }

  function dispatchCartEvent(cart) {
    document.dispatchEvent(new CustomEvent("versio:cart:updated", { detail: { cart } }));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }

  function getVariantIdFromUrl() {
    try {
      const url = new URL(window.location.href);
      const v = url.searchParams.get("variant");
      return v ? String(v) : "";
    } catch {
      return "";
    }
  }

  function getCurrentVariantId(form, fallbackId) {
    const idInput = form ? form.querySelector('[name="id"]') : null;
    const formValue = idInput && idInput.value ? String(idInput.value) : "";
    return formValue || getVariantIdFromUrl() || (fallbackId ? String(fallbackId) : "");
  }

  function parseVariantsJson(blockEl) {
    const script = blockEl.querySelector("[data-versio-sticky-atc-variants]");
    if (!script) return [];
    try {
      const parsed = JSON.parse(script.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  let measureCanvas = null;
  function ensureMeasureContext() {
    if (!measureCanvas) measureCanvas = document.createElement("canvas");
    const ctx = measureCanvas.getContext && measureCanvas.getContext("2d");
    return ctx || null;
  }

  function fontStringFromComputedStyle(cs) {
    const font = String(cs.font || "").trim();
    if (font) return font;

    const style = String(cs.fontStyle || "normal");
    const variant = String(cs.fontVariant || "normal");
    const weight = String(cs.fontWeight || "400");
    const size = String(cs.fontSize || "16px");
    const family = String(cs.fontFamily || "sans-serif");
    return style + " " + variant + " " + weight + " " + size + " " + family;
  }

  function autosizeSelect(selectEl) {
    if (!selectEl) return;
    const opt = selectEl.options && selectEl.options[selectEl.selectedIndex];
    if (!opt) return;

    const cs = window.getComputedStyle(selectEl);
    const ctx = ensureMeasureContext();
    const text = String(opt.textContent || "").trim();
    let textWidth = text.length * 8;
    if (ctx) {
      ctx.font = fontStringFromComputedStyle(cs);
      textWidth = ctx.measureText(text).width;
    }

    const paddingLeft = 12;
    const paddingRight = 34;
    const borderLeft = parseFloat(cs.borderLeftWidth) || 0;
    const borderRight = parseFloat(cs.borderRightWidth) || 0;

    const extra = 2;
    const minWidth = 0;
    const width = Math.ceil(textWidth + paddingLeft + paddingRight + borderLeft + borderRight + extra);
    const finalWidth = Math.max(minWidth, width) + "px";
    selectEl.style.setProperty("width", finalWidth, "important");
    selectEl.style.setProperty("min-width", "0px", "important");
    selectEl.style.setProperty("flex", "0 0 auto", "important");
  }

  function readTemplateHtml(blockEl, selector) {
    const tpl = blockEl.querySelector(selector);
    if (!tpl) return "";
    return String(tpl.innerHTML || "").trim();
  }

  function setButtonState(buttonEl, state) {
    if (!buttonEl) return;
    if (!state || state === "idle") {
      buttonEl.removeAttribute("data-state");
      buttonEl.removeAttribute("aria-busy");
      return;
    }
    buttonEl.setAttribute("data-state", state);
    buttonEl.setAttribute("aria-busy", state === "loading" ? "true" : "false");
  }

  function watchCartEvents(onEvent) {
    const handler = function() {
      try {
        onEvent();
      } catch {}
    };
    const events = ["versio:cart:updated", "cart:updated", "cart:refresh"];
    events.forEach((evt) => document.addEventListener(evt, handler));
    return function cleanup() {
      events.forEach((evt) => document.removeEventListener(evt, handler));
    };
  }

  async function waitForAddedToCart(variantId, initialCart, maxMs) {
    const start = Date.now();
    const initialCount = initialCart && typeof initialCart.item_count === "number" ? initialCart.item_count : -1;
    const id = String(variantId || "");

    let eventSeenAt = 0;
    const stopWatching = watchCartEvents(function() {
      if (!eventSeenAt) eventSeenAt = Date.now();
    });

    try {
      while (Date.now() - start < (maxMs || 2400)) {
        if (eventSeenAt && Date.now() - eventSeenAt > 60) {
          try {
            const cart = await fetchCart();
            if (variantInCart(cart, id)) return cart;
            if (initialCount >= 0 && typeof cart.item_count === "number" && cart.item_count > initialCount) {
              return cart;
            }
          } catch {}
          return null;
        }

        try {
          const cart = await fetchCart();
          if (variantInCart(cart, id)) return cart;
          if (initialCount >= 0 && typeof cart.item_count === "number" && cart.item_count > initialCount) {
            return cart;
          }
        } catch {}

        await new Promise((r) => window.setTimeout(r, eventSeenAt ? 120 : 200));
      }
    } finally {
      stopWatching();
    }

    return null;
  }

  function setVisible(blockEl, isVisible) {
    blockEl.classList.toggle("versio-sticky-atc--visible", !!isVisible);
    blockEl.setAttribute("aria-hidden", isVisible ? "false" : "true");
  }

  function initBlock(blockEl) {
    if (!blockEl || blockEl.dataset.versioInitialized === "true") return;
    blockEl.dataset.versioInitialized = "true";

    portalize(blockEl);

    const initialVariantId = String(blockEl.getAttribute("data-initial-variant-id") || "");
    const variants = parseVariantsJson(blockEl);

    const imageEl = blockEl.querySelector("[data-versio-sticky-atc-image]");
    const priceEl = blockEl.querySelector("[data-versio-sticky-atc-price]");
    const compareEl = blockEl.querySelector("[data-versio-sticky-atc-compare]");
    const buttonEl = blockEl.querySelector("[data-versio-sticky-atc-submit]");

    const buttonLabelHtml =
      readTemplateHtml(blockEl, "template[data-versio-sticky-btn-label]") || "Add to cart";
    if (buttonEl) buttonEl.innerHTML = buttonLabelHtml;

    const form = findProductForm(document);
    const submit = findSubmitButton(form);
    const idInput = form ? form.querySelector('[name="id"]') : null;
    let buyButtonsTarget = findBuyButtonsTarget(form, submit);

    function findVariantById(variantId) {
      const id = String(variantId || "");
      return variants.find((v) => v && String(v.id) === id) || null;
    }

    function getSelectedOptionValues() {
      const selects = Array.from(blockEl.querySelectorAll("[data-versio-sticky-atc-option-select]"));
      if (!selects.length) return null;
      selects.sort((a, b) => Number(a.dataset.optionIndex || 0) - Number(b.dataset.optionIndex || 0));
      return selects.map((s) => String(s.value || ""));
    }

    function findMatchingVariantByOptions() {
      const selected = getSelectedOptionValues();
      if (!selected) return null;
      return (
        variants.find((v) => {
          if (!v || !Array.isArray(v.options)) return false;
          if (v.options.length !== selected.length) return false;
          return v.options.every((opt, i) => String(opt) === String(selected[i]));
        }) || null
      );
    }

    function syncSelectsToVariant(variant) {
      if (!variant || !Array.isArray(variant.options)) return;
      const selects = Array.from(blockEl.querySelectorAll("[data-versio-sticky-atc-option-select]"));
      if (!selects.length) return;

      selects.sort((a, b) => Number(a.dataset.optionIndex || 0) - Number(b.dataset.optionIndex || 0));
      selects.forEach((selectEl, idx) => {
        const next = variant.options[idx];
        if (typeof next === "undefined") return;
        if (String(selectEl.value) !== String(next)) selectEl.value = String(next);
        autosizeSelect(selectEl);
      });
    }

    function setThemeVariantId(nextVariantId) {
      if (!form) return;
      const target = form.querySelector('[name="id"]');
      if (!target) return;
      const previous = String(target.value || "");
      const next = String(nextVariantId || "");
      if (!next || previous === next) return;
      target.value = next;
      try {
        target.dispatchEvent(new Event("input", { bubbles: true }));
        target.dispatchEvent(new Event("change", { bubbles: true }));
      } catch {}
    }

    function getActiveVariant() {
      const fromTheme = findVariantById(getCurrentVariantId(form, initialVariantId));
      if (fromTheme) return fromTheme;
      const fromSelects = findMatchingVariantByOptions();
      if (fromSelects) return fromSelects;
      return findVariantById(initialVariantId);
    }

    function applyVariant(variant) {
      if (!variant) return;

      if (priceEl) priceEl.textContent = variant.priceFormatted || "";

      const priceCents = Number(variant.priceCents || 0);
      const compareCents = Number(variant.compareCents || 0);
      const showCompare = compareCents > priceCents && !!variant.compareFormatted;
      if (compareEl) {
        compareEl.textContent = showCompare ? variant.compareFormatted : "";
        compareEl.hidden = !showCompare;
      }

      if (imageEl && variant.imageUrl) {
        const currentSrc = imageEl.getAttribute("src") || "";
        if (String(currentSrc) !== String(variant.imageUrl)) {
          imageEl.setAttribute("src", String(variant.imageUrl));
        }
      }
    }

    function sync() {
      const currentVariant = getActiveVariant();
      if (currentVariant) {
        syncSelectsToVariant(currentVariant);
        applyVariant(currentVariant);
      }

      if (!buttonEl) return;

      const state = buttonEl.getAttribute("data-state") || "";
      if (state === "loading" || state === "success") return;

      const variantAvailable = currentVariant ? !!currentVariant.available : true;
      const themeDisabled = submit ? !!submit.disabled : false;
      const shouldDisable = !variantAvailable || themeDisabled || !form;
      buttonEl.disabled = shouldDisable;
      buttonEl.innerHTML = buttonLabelHtml;
    }

    function onScroll() {
      if (!form) {
        setVisible(blockEl, false);
        return;
      }
      if (!buyButtonsTarget || !document.contains(buyButtonsTarget)) {
        buyButtonsTarget = findBuyButtonsTarget(form, submit);
      }
      if (!buyButtonsTarget) {
        setVisible(blockEl, false);
        return;
      }

      const rect = buyButtonsTarget.getBoundingClientRect();
      const triggerOffset = 90;
      const hasReachedTopZone = rect.top <= triggerOffset;
      setVisible(blockEl, hasReachedTopZone);
    }

    let ticking = false;
    function onScrollThrottled() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function() {
        ticking = false;
        onScroll();
      });
    }

    window.addEventListener("scroll", onScrollThrottled, { passive: true });
    window.addEventListener("resize", onScrollThrottled);
    onScroll();

    if (form) {
      form.addEventListener("change", function() {
        sync();
      });
      form.addEventListener("input", function() {
        sync();
      });
    }

    blockEl.querySelectorAll("[data-versio-sticky-atc-option-select]").forEach((selectEl) => {
      selectEl.addEventListener("change", function() {
        autosizeSelect(selectEl);
        const match = findMatchingVariantByOptions();
        if (!match) return;
        setThemeVariantId(match.id);
        sync();
      });
      autosizeSelect(selectEl);
    });

    if (idInput) {
      const obs = new MutationObserver(function() {
        sync();
      });
      obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
    }

    let lastVariantId = "";
    window.setInterval(function() {
      const nextId = getCurrentVariantId(form, initialVariantId);
      if (nextId && nextId !== lastVariantId) {
        lastVariantId = nextId;
        sync();
      }
    }, 400);

    document.addEventListener("cart:updated", function() {
      sync();
    });
    document.addEventListener("cart:refresh", function() {
      sync();
    });

    if (buttonEl) {
      buttonEl.addEventListener("click", async function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (buttonEl.disabled) return;
        if ((buttonEl.getAttribute("data-state") || "") === "loading") return;

        const activeVariant = getActiveVariant();
        const currentVariantId = activeVariant ? String(activeVariant.id || "") : "";
        if (!currentVariantId) return;
        if (activeVariant && !activeVariant.available) return;

        buttonEl.disabled = true;
        setButtonState(buttonEl, "loading");

        const failSafe = window.setTimeout(function() {
          setButtonState(buttonEl, "idle");
          buttonEl.disabled = false;
          sync();
        }, 7000);

        try {
          let initialCart = null;
          try {
            initialCart = await fetchCart();
          } catch {}

          let themeHandledSubmit = false;
          if (submit) {
            try {
              const ev = new MouseEvent("click", { bubbles: true, cancelable: true, view: window });
              const dispatched = submit.dispatchEvent(ev);
              themeHandledSubmit = !dispatched || ev.defaultPrevented;
            } catch {}
          }

          if (!themeHandledSubmit) {
            if (form && typeof form.requestSubmit === "function") {
              form.requestSubmit(submit || undefined);
            } else if (submit) {
              submit.click();
            } else {
              await addToCartFallback(currentVariantId);
              const cart = await fetchCart();
              dispatchCartEvent(cart);
            }
          }

          const cart = await waitForAddedToCart(currentVariantId, initialCart, 2400);
          if (cart) dispatchCartEvent(cart);

          setButtonState(buttonEl, "success");
          window.setTimeout(function() {
            setButtonState(buttonEl, "idle");
            buttonEl.disabled = false;
            sync();
          }, 650);
        } catch (err) {
          console.warn("Versio sticky ATC add failed:", err);
          setButtonState(buttonEl, "idle");
          buttonEl.disabled = false;
          sync();
        } finally {
          window.clearTimeout(failSafe);
        }
      });
    }

    sync();
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll("[data-versio-sticky-atc]").forEach(initBlock);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
      const sectionId = event && event.detail && event.detail.sectionId;
      const root = sectionId
        ? document.getElementById("shopify-section-" + sectionId)
        : document;
      initAll(root);
    });

    document.addEventListener("shopify:section:unload", function(event) {
      const sectionId = event && event.detail && event.detail.sectionId;
      if (!sectionId) return;
      const portal = document.getElementById("versio-sticky-atc-portal");
      if (!portal) return;
      portal.querySelectorAll("[data-versio-sticky-atc]").forEach((el) => {
        if (el && el.dataset && el.dataset.versioSectionId === "shopify-section-" + sectionId) {
          el.remove();
        }
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
